// extracted by mini-css-extract-plugin
export default {"categories_page":"style_categories_page__5-T7s","title":"style_title__sagEI","categories":"style_categories__01ai-"};